import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';
import ab from '../assets/images/vendor-module-development-head.jpg';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const Vendor = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Navbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<div
				style={{
					backgroundImage: `url(${ab})`,
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					Vendor Module
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					Vendor Module Development{' '}
				</h6>
			</div>

			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					Vendor Module Development
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/b2c2-ecommerce.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								An Online E-Commerce Portal can sale products or services of
								multiple sellers by making them a supplier or vendor. The Vendor
								Module in an E-Commerce is owned and operated by the E-Commerce
								company. This system allows to create n number of supplier
								dashboards from where any supplier or vendor can add their old
								or new products to on a fixed-price at their online platform.
								All these added products display on B2C and B2B E-Commerce
								portal.
							</p>
							<br />
							<p>
								Vendor can control their dashboard individually to view and
								manage their products and orders. The technology of Arya
								Aviation can help the admin to take full control of handling
								sellers, manage the track of the sales, manage the inventory,
								price setting and commissions rates etc.
							</p>

							<br />
							<p>
								You can get your E-Commerce website with technology-enabled
								vendor module feature that help you to grow your business by
								earning from more products sales of multiple categories and by
								saving your time and money. Arya Aviation technology enabled
								cloud based solution for your stock, suppliers or vendors,
								order, buyers, staff and accounting also helps to track your
								business activity from anywhere anytime.
							</p>

							<br />
							<p>
								As our team has years of great experience in the Information
								Technology Industry so we develop Vendor Module with all updated
								features. Arya Aviation provides a technically strong and
								reliable Vendor Portal Solution so you and your
								sub-suppliers/vendor along together can grow your business.
							</p>
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default Vendor;
